import { useAuth } from 'react-oidc-context';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { ApiController } from 'core/api/client-portal/autogenerated/Api';
import { Interceptors } from 'core/api/client-portal/autogenerated/http-client';

export function useViewController() {
    const auth = useAuth();

    const interceptors: Interceptors = {
        request: [
            {
                onFulfilled: (config) => {
                    if (!config.headers) config.headers = {};

                    config.headers['Cache-FormControl'] =
                        'no-cache, no-store, must-revalidate';
                    config.headers['Pragma'] = 'no-cache';
                    config.headers['Expires'] = '0';

                    return config;
                }
            }
        ],
        response: [
            {
                onFulfilled: (response: AxiosResponse<unknown>) => {
                    return response;
                },
                onRejected: async (error: AxiosError) => {
                    console.log('Error in response interceptor');
                    if (error.response?.status === 401) {
                        const user = await auth.signinSilent();

                        const config =
                            (error.config as Record<string, unknown>) ?? {};
                        config.headers = {
                            authorization: `Bearer ${user?.access_token}`,
                            'Cache-Control':
                                'no-cache, no-store, must-revalidate',
                            Expires: '0',
                            Pragma: 'no-cache',
                            withCredentials: true
                        };

                        if (!config._retry && error.response?.status === 401) {
                            config._retry = true;

                            return new Promise((resolve) => {
                                setTimeout(() => {
                                    console.log(
                                        'Retrying viewApiController >',
                                        config
                                    );
                                    resolve(axios(config));
                                }, 2000);
                            });
                        }

                        return Promise.reject(error);
                    }
                }
            }
        ]
    };

    return new ApiController({
        interceptors,
        securityWorker: () => ({
            headers: {
                Authorization: `Bearer ${auth.user?.access_token}`
            }
        })
    });
}
